import { z } from 'zod';
import {
    CarDamageCreateForm,
    CarDamageCreateFormErrors,
    CarDamageCreateFormErrorsSchema,
} from '@/types/car/car-damage-create-form.type.ts';

export type CarDamageUpdateForm = CarDamageCreateForm & {
    id: number,
    deleted_photo_id: number | null,
};

export type CarDamageUpdateFormErrors = CarDamageCreateFormErrors & {
    id?: string[],
    deleted_photo_id?: string[],
};

export const CarDamageUpdateFormErrorsSchema = CarDamageCreateFormErrorsSchema.extend({
    id: z.array(z.string()).optional(),
    deleted_photo_id: z.array(z.string()).optional(),
});
